import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import type { Challenge } from '../types'

export function useChallenges() {
  const [challenges, setChallenges] = useState<Challenge[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    async function fetchChallenges() {
      try {
        const { data, error } = await supabase
          .from('challenges')
          .select('*')
          .order('created_at', { ascending: false })

        if (error) throw error
        setChallenges(data || [])
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to fetch challenges'))
      } finally {
        setLoading(false)
      }
    }

    fetchChallenges()
  }, [])

  return { challenges, loading, error }
}